import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { TokenStorageService } from '../../services/storage/token-storage.service';
import { UserService } from '../../services/user.service';
import { SessionService } from '../../services/session/session.service';

@Component({
    selector: 'app-add-bank-account',
    templateUrl: './add-bank-account.component.html',
    styleUrls: ['./add-bank-account.component.css'],
    standalone: false
})
export class AddBankAccountComponent implements OnInit {
  AddBankAccSubmitted: boolean = false;
  bankAccForm: FormGroup = new FormGroup({});
  errorMessage: string = '';
  loading: boolean = false;
  banks: any;
  assignBanks: any;

  bankAssigned: any;
  currencyList: any;
  addBankAccModalRef: MdbModalRef<AddBankAccountModalComponent> | null = null;
  bankDetails: any;
  isTableEmptyBank: boolean = false;
  isUpdate: boolean = false;
  notAddedBankAcc: boolean = true;
  showError: boolean = false;
  env:any;
  constructor(
    private userService: UserService,
    private modalService: MdbModalService,
    private session : SessionService,
    private toastr: ToastrService,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
    this.env = this.tokenStorage.getUserEnv();
  }
  public initialize(data: any) {
    this.bankAssigned = data.bank
    this.assignBanks = data.bankList
  }

  openAddBankAccModal() {
    let institution = this.session.getItem("newInstCode");

    this.addBankAccModalRef = this.modalService.open(
      AddBankAccountModalComponent,
      {
        modalClass: 'modal-lg modal-dialog-centered',
        data: {
          code: institution,
          bankList: this.assignBanks
        },
      }
    );
    this.addBankAccModalRef?.onClose.subscribe((message: any) => {
      this.bankAccList();
    });

  }

  openEditBankAccModal(bank: any) {
    this.userService.getBankAccountDetails(this.session.getItem("newInstCode"), bank.bankId, 'asia').subscribe((data: any) => {

      this.isUpdate = true;
      if (data.status == 'SUCCESS') {
        let bankAccDetails = data.bankAccountList[0];

        this.addBankAccModalRef = this.modalService.open(
          AddBankAccountModalComponent,
          {
            modalClass: 'modal-lg modal-dialog-centered',
            data: {
              code: this.session.getItem("newInstCode"),
              bankList: this.assignBanks,
              bankAccountId: bankAccDetails.bankAccountId,
              bankAccountNumber: bankAccDetails.bankAccountNumber,
              bankId: bankAccDetails.bankId,
              bankName: bankAccDetails.bankName,
              branch: bankAccDetails.branch,
              contactName: bankAccDetails.contactName,
              contactNo: bankAccDetails.contactNo,
              currency: bankAccDetails.currency,
              isDefault: bankAccDetails.isDefault,
              isUpdate: this.isUpdate,
            },
          }
        );
        this.addBankAccModalRef?.onClose.subscribe((message: any) => {
          this.bankAccList();
        });
      } else {
        this.toastr.error(
          'Error getting bank account list'
        );
      }
    });



  }


  bankAccList() {
    this.userService.getBankAccountDetails(this.session.getItem("newInstCode"), "", 'asia').subscribe((data: any) => {

      this.isTableEmptyBank = false;

      if (data.status == 'SUCCESS') {
        this.bankDetails = data;

        if (this.bankDetails.bankAccountList == null || this.bankDetails.bankAccountList == '') {
          this.isTableEmptyBank = true;
          this.notAddedBankAcc = true;
        }else{
          this.isTableEmptyBank = false;
          this.notAddedBankAcc = false;
          this.showError = false;
        }
      } else {
        this.isTableEmptyBank = true;
      }
    });
  }

}
@Component({
    selector: 'app-add-bank-account-modal',
    templateUrl: './add-bank-account-modal.html',
    styleUrls: ['./add-bank-account.component.css'],
    standalone: false
})
export class AddBankAccountModalComponent implements OnInit {
  @Input() bankAssigned: any;
  @Input() currencyList: any;

  AddBankAccSubmitted: boolean = false;
  bankAccForm: FormGroup = new FormGroup({});
  errorMessage: string = '';
  loading: boolean = false;
  banks: any;
  // assignBanks:any;
  code: any;
  bankList: any;

  bankAccountId: any;
  bankAccountNumber: any;
  bankId: any;
  bankName: any;
  branch: any;
  contactName: any;
  contactNo: any;
  currency: any;
  isDefault: any;
  isUpdate: any;
  originalData: any;
  con: any;
  env:any;

  // bankAssigned: any;
  // currencyList: any;

  constructor(
    public modalRef: MdbModalRef<AddBankAccountModalComponent>,
    private router: Router,
    private toastr: ToastrService,
    private userService: UserService,
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {

    this.bankAccForm.markAsPristine();
    this.initializeBankAccForm();
    this.getCurrencyList();
    this.getCountryCode()
    this.env = this.tokenStorage.getUserEnv();
  }

  getCurrencyList() {
    this.userService.getCurrencyList().subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.currencyList = data.list.sort((a: any, b: any) =>
            a.type > b.type ? 1 : -1
          );
        } else {
          this.errorMessage = data.reason;
          this.toastr.error(
            this.errorMessage,
            'Error getting currency list'
          );
        }
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.toastr.error(
          this.errorMessage,
          'Error getting currency list'
        );
      },
    });
  }
  isFormDirty(): boolean {
    return this.bankAccForm.dirty;

  }



  initializeBankAccForm(): void {
    this.bankAccForm = this.formBuilder.group({
      bankAccBank: ['', [Validators.required]],
      bankAccBranch: ['', [Validators.required]],
      bankAccNumber: ['', [Validators.required]],
      bankAccCurrency: ['', [Validators.required]],
      bankAccContactName: ['', [Validators.required]],
      bankAccContactNumber: [''],
      contactNumber: [''],
      isDefault: [''],
    });
    this.loadData();

  }

  loadData() {
    // Replace this with your API call or other data loading logic
    this.originalData = {
      bankAccBank: this.bankId,
      bankAccBranch: this.branch,
      bankAccNumber: this.bankAccountNumber,
      bankAccCurrency: this.currency,
      bankAccContactName: this.contactName,
      contactNumber: this.contactNo?.split('-')[1],
      isDefault: this.isDefault == 'YES' ? true : false
    };

    // Set the form values to the loaded data
    this.bankAccForm.patchValue(this.originalData);
    setTimeout(() => {
      this.bankAccForm.markAsPristine();
    }, 100);


  }
  getCountryCode(){
    this.userService.getIp().subscribe((ip) => {
      this.userService.getCountryCode(ip).subscribe((code) => {
        const contryCode = JSON.parse(code).country_calling_code;
        this.bankAccForm.controls['bankAccContactNumber'].setValue(contryCode+"-00000000");
        this.con = contryCode;
      });
    });
  }

  onClickAddBankAccount() {
    this.AddBankAccSubmitted = true;
    if (this.bankAccForm.invalid) {
      this.toastr.error('Please fill the form', 'Error');
      return;
    }

    this.loading = true;
    const {
      bankAccBank,
      bankAccBranch,
      bankAccNumber,
      bankAccCurrency,
      bankAccContactName,
      bankAccContactNumber,
      contactNumber,
      isDefault
    } = this.bankAccForm.value;

    this.userService
      .createInstBankAcc(
        bankAccNumber,
        bankAccBank,
        this.code,
        bankAccCurrency,
        0,
        1,
        bankAccBranch,
        bankAccContactName,
        contactNumber ? this.con + "-" + contactNumber : '',
        isDefault == true ? "YES" : "NO"
      )
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {
            this.toastr.success('Bank Account created successfully', 'Success');
            this.AddBankAccSubmitted = false;
            this.bankAccForm.reset();
            this.modalRef.close();
          } else {
            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to create Bank Account'
            );
          }
        },
        error: (err) => {
          this.loading = false;
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to create Bank Account'
          );
        },
      });

  }
  onClickUpdateBankAccount() {
    this.AddBankAccSubmitted = true;
    if (this.bankAccForm.invalid) {
      this.toastr.error('Please fill the form', 'Error');
      return;
    }

    this.loading = true;
    const {
      bankAccBank,
      bankAccBranch,
      bankAccNumber,
      bankAccCurrency,
      bankAccContactName,
      bankAccContactNumber,
      contactNumber,
      isDefault
    } = this.bankAccForm.value;

    this.userService
      .updateInstBankAcc(
        this.bankAccountId,
        bankAccNumber,
        bankAccBank,
        this.code,
        bankAccCurrency,
        0,
        1,
        bankAccBranch,
        bankAccContactName,
        contactNumber ? this.con + "-" + contactNumber : '',
        isDefault == true ? "YES" : "NO"
      )
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {
            this.toastr.success('Bank Account updated successfully', 'Success');
            this.modalRef.close();
          } else {
            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to update Bank Account'
            );
          }
        },
        error: (err) => {
          this.loading = false;
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to update Bank Account'
          );
        },
      });

  }

  reloadPage(): void {
    window.location.reload();
  }

  get formInstControl(): { [key: string]: AbstractControl } {
    return this.bankAccForm.controls;
  }



  public close() {
    this.modalRef.close();
  }
}
